module.exports = __webpack_public_path__ + "static/img/RWDAG.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/RWDAG.png
// module id = WX6n
// module chunks = 0